export class TimeOutClass {
    private static instance: TimeOutClass;
    private idTimeout: ReturnType<typeof setTimeout> | number | null = null;

    private constructor() { }

    public static getInstance(): TimeOutClass {
        if (!TimeOutClass.instance) {
            TimeOutClass.instance = new TimeOutClass();
        }
        return TimeOutClass.instance;
    }

    public getIdTimeout(): ReturnType<typeof setTimeout> | number | null {
        return this.idTimeout;
    }

    public setIdTimeout(id: ReturnType<typeof setTimeout> | number): void {
        // ✅ ANNULER LE TIMEOUT EXISTANT AVANT D'EN CRÉER UN NOUVEAU
        if (this.idTimeout !== null) {
            clearTimeout(this.idTimeout);
            // console.warn('⚠️ Timeout existant annulé et remplacé');
        }
        this.idTimeout = id;
    }

    public clearIdTimeout(): void {
        if (this.idTimeout !== null) {
            clearTimeout(this.idTimeout);
            this.idTimeout = null;
        }
    }

}